import { FunctionComponent } from "react";
import { CarrotIcon } from "@/components/common/icons";
import { Button, Skeleton } from "@mantine/core";
import { LinkIcon } from "@/form/components/common/icons";
import { V2Validator, SortKey } from "@/services/network/validator";
import {
  numberWithCommas,
  stakedAmountDisplay,
  katAmountDesc,
  amountDesc,
} from "@/utils/format";
import Image from "next/image";
import BigNumber from "bignumber.js";

const CaptainListCard: FunctionComponent<{
  validator: V2Validator;
  itemWidth: number;
  dataKey: SortKey;
  onEvent: (id: string, event: string) => void;
}> = function ({ validator, itemWidth, onEvent, dataKey }) {
  let image = validator.avatar || validator.imageUrl;

  const width = itemWidth || 150;
  const height = width * 1.2;

  return (
    <div
      className={`flex flex-col justify-between bg-cover border border-[#E0E1E1]  rounded-lg overflow-hidden group cursor-pointer relative min-h-[10vw] transition-all  ${
        itemWidth > 50 ? "" : "opacity-0"
      }`}
      style={{
        width,
      }}
    >
      <Image
        className="rounded-lg overflow-hidden"
        src={image || "/karatdao.jpg"}
        layout="fixed"
        loading="lazy"
        width={width}
        height={width}
        placeholder="blur"
        objectFit="cover"
        blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNcVQoAAc8BIaDXu+0AAAAASUVORK5CYII="
      ></Image>
      <div className="flex justify-between p-2 absolute top-0 left-0 w-full">
        <div
          className="p-1 bg-white/50 rounded-[4px] text-dark1 text-sm"
          style={{
            backdropFilter: "blur(5px)",
          }}
        >
          #{validator.tokenId}
        </div>
      </div>

      <div className="p-4 flex flex-col gap-2">
        {validator.validatorName && (
          <div className="font-semibold text-sm">{validator.validatorName}</div>
        )}

        {dataKey === "stakedAmount" && (
          <div
            className="flex justify-between bg-white/75 w-full"
            style={
              {
                // backdropFilter: "blur(5px)",
              }
            }
          >
            <div className="w-full leading-none">
              <div className="flex justify-between items-center text-sm">
                <div className="text-sm">
                  {amountDesc(parseFloat(validator.stake.stakedAmount), 2)} KAT
                </div>
                <div className="text-sm text-right">
                  {amountDesc(
                    parseFloat(validator.stake?.lastDayReturn || "0")
                  ) || "0"}{" "}
                  KAT
                </div>
              </div>
              <div className="flex justify-between items-center text-xs">
                <div className="text-[#585858] text-xs">Staked</div>
                <div className="text-[#585858] text-xs whitespace-nowrap">
                  Last day return
                </div>
              </div>
            </div>
          </div>
        )}

        {(dataKey === "apy" ||
          dataKey === "lastDayReturn" ||
          dataKey === "tokenId") && (
          <div
            className="flex justify-between bg-white/75 w-full"
            style={
              {
                // backdropFilter: "blur(5px)",
              }
            }
          >
            <div className="w-full leading-none">
              <div className="flex justify-between items-center text-sm">
                <div className="text-sm">
                  {((validator.stake.apy || 0) * 100).toFixed(2)}%{" "}
                </div>
                <div className="text-sm text-right">
                  {amountDesc(
                    parseFloat(validator.stake?.lastDayReturn || "0")
                  ) || "0"}{" "}
                  KAT
                </div>
              </div>
              <div className="flex justify-between items-center text-xs">
                <div className="text-[#585858] text-xs">APY</div>
                <div className="text-[#585858] text-xs whitespace-nowrap">
                  Last day return
                </div>
              </div>
              {/* <div className="">
                <div className="text-sm">
                  {((validator.stake.apy || 0) * 100).toFixed(2)}%{" "}
                </div>
                <div className="text-[#585858] text-xs">APY</div>
              </div>
              <div className="">
                <div className="text-sm text-right">
                  {amountDesc(
                    parseFloat(validator.stake?.lastDayReturn || "0")
                  ) || "0"}{" "}
                  KAT
                </div>
                <div className="text-[#585858] text-xs whitespace-nowrap">
                  Last day return
                </div>
              </div> */}
            </div>
          </div>
        )}

        {dataKey === "earnings" && (
          <div
            className="flex justify-between bg-white/75 w-full"
            style={
              {
                // backdropFilter: "blur(5px)",
              }
            }
          >
            <div className="w-full flex items-center justify-between text-sm leading-none">
              <div>{((validator.stake.apy || 0) * 100).toFixed(2)}% APY</div>
              <div className="font-semibold">
                {numberWithCommas(
                  parseFloat(validator.userStake?.stakedAmount || "0")
                )}{" "}
                KAT
              </div>
            </div>
          </div>
        )}
      </div>

      <div
        className="group-hover:opacity-100 opacity-0  flex absolute w-full h-full left-0 top-0 bg-black/50 rounded-lg  items-center justify-center transition-all"
        style={{
          backdropFilter: "blur(1px)",
        }}
      >
        <div className="px-4 flex flex-col items-center gap-2">
          <div
            className="w-[140px] h-[40px] flex items-center justify-center rounded-full bg-primary text-white text-xs font-semibold cursor-pointer transition-all hover:scale-[0.95]"
            onClick={() => {
              onEvent(validator.tokenId, "view_detail");
            }}
          >
            Stake more
          </div>
          {/* <div className="w-[140px] h-[40px] flex items-center justify-center rounded-full bg-white text-primary text-xs font-semibold cursor-pointer transition-all hover:scale-[0.95]">
            <LinkIcon className="w-6"></LinkIcon>
            <span className="ml-1">Copy Link</span>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default CaptainListCard;
